module.exports = __webpack_public_path__ + "img/Feed_PESQUISA-PLOA-2025.18bd7760.gif";